import React, { FC, Dispatch, SetStateAction } from 'react'
import styled from 'styled-components'
import { Divider, InputNumber, Typography } from 'antd'

import { FlexColumn, FlexRow } from '../../../FlexboxReusables/FlexItems'
import { CourseAvailableForPurchasePreview } from '../../types'
import { ShoppingCart } from 'react-feather'
import { FormattedMessage } from 'react-intl'
import { displayPrice } from '../../../GenerateInvoice/invoiceUtils'

type ParticipantsStepProps = {
  course: CourseAvailableForPurchasePreview
  isPartner: boolean
  partnerDiscountPercentage: number
  numberOfParticipants: number
  setNumberOfParticipants: Dispatch<SetStateAction<number>>
}

export const ParticipantsStep: FC<ParticipantsStepProps> = ({
  course,
  isPartner,
  partnerDiscountPercentage,
  numberOfParticipants,
  setNumberOfParticipants
}) => {
  const partnerDiscount = isPartner ? partnerDiscountPercentage : 0
  const bulkDiscount = numberOfParticipants >= 10 ? 5 : 0
  const totalDiscountPercentage = partnerDiscount + bulkDiscount
  
  const totalPrice = numberOfParticipants * course.purchasePrice * (1 - totalDiscountPercentage / 100)

  return (
    <>
      <StyledFlexRow>
        <Typography.Title level={4}>
          <FormattedMessage id='buyCourseAccess.pricePerParticipant' />:
          {totalDiscountPercentage > 0 && (
            <FlexRow justifyContent='flex-start'>
              <StrikeThroughText>{displayPrice(course.purchasePrice, 'EUR')}</StrikeThroughText>
            </FlexRow>
          )}
          {isPartner && (
            <FlexRow justifyContent='flex-start'>
              <Typography.Title level={5}> -{partnerDiscountPercentage}% Partnerrabatt</Typography.Title>
            </FlexRow>
          )}
          {numberOfParticipants >= 10 && (
            <FlexRow justifyContent='flex-start'>
              <Typography.Title level={5}> -5% Mengenrabatt</Typography.Title>
            </FlexRow>
          )}
          <FlexRow justifyContent='flex-start'>
            {displayPrice(course.purchasePrice, 'EUR', totalDiscountPercentage)}
          </FlexRow>
        </Typography.Title>
      </StyledFlexRow>
      <StyledFlexRow>
        <FlexColumn alignItems='center'>
          <LabelText>
            <FormattedMessage id='buyCourseAccess.numberOfParticipants' />:
          </LabelText>
          <StyledInputNumber
            placeholder="0"
            min={0}
            max={999}
            onChange={(value) => setNumberOfParticipants(value as number)}
          />
        </FlexColumn>
      </StyledFlexRow>
      <Divider style={{ width: '70%' }}/>
      <HighlightedRow>
        <ShoppingCart size={24} style={{ marginRight: '1em' }}/>
        <Typography.Text>
          <FormattedMessage id='buyCourseAccess.totalPrice' />:
          {displayPrice(totalPrice, 'EUR')}
        </Typography.Text>
      </HighlightedRow>
    </>
  )
}

export default ParticipantsStep

const StyledInputNumber = styled(InputNumber)`
  width: 30%;

  @media (max-width: 768px) {
    width: 100%;
  }
`

const LabelText = styled(Typography.Text)`
  margin-right: 1em;
`

const StyledFlexRow = styled(FlexRow)`
  margin: 2em auto;
  width: 70%;
  justify-content: center;
`

const HighlightedRow = styled(StyledFlexRow)`
  width: 30%;
  background-color: #f2f4f6;
  font-weight: 500;
  padding: 10px 20px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  align-items: center;

  @media (max-width: 768px) {
    width: 100%;
  }
`

const StrikeThroughText = styled.div`
  text-decoration: line-through;
  color: grey;
`